<template>
    <div class="companyDetailsMain" :class="$IsMobile ? 'mobile' : ''">
        <div class="companyTit" v-if="!$IsMobile">
            <div class="container clearfix">
                <div class="left fl">
                    <img :src="'/files?imagePath=' + enterpriseInfo.logo" alt=""/>
                    <div class="info">
                        <h3>{{ enterpriseInfo.shortName }}</h3>
                        <el-button type="primary" @click="openWebsite(enterpriseInfo.website)"
                                   v-if="enterpriseInfo.website">访问官网
                        </el-button>
                        <p class="textInfo">
                            <span>{{ industryFormatter(enterpriseInfo.industry) }}</span>
                            <span>{{ enterpriseInfo.econKind }}</span>
                            <span>{{ enterpriseInfo.personScope }}</span>
                        </p>
                        <p class="tags">
                            <el-tag v-for="(item, index) in label" :key="index">{{ item }}</el-tag>
                        </p>
                    </div>
                </div>
                <ul class="right">
                    <li>
                        <p>{{ enterpriseInfo.totalPublicJobNum }}</p>
                        <span>全部职位</span>
                    </li>
                    <li>
                        <p>{{ enterpriseInfo.recruitJobNum }}</p>
                        <span>在招职位</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="companyTit-mobile" v-else>
            <div class="info-container">
                <img :src="'/files?imagePath=' + enterpriseInfo.logo" alt=""/>
                <div class="info">
                    <h3> {{ enterpriseInfo.shortName }}
                        <el-button type="primary" @click="openWebsite(enterpriseInfo.website)"
                                   v-if="enterpriseInfo.website">访问官网
                        </el-button>
                    </h3>
                    <p class="textInfo">
                        <span style="white-space: nowrap">{{ industryFormatter(enterpriseInfo.industry) }}</span>
                        <span style="white-space: nowrap">{{ enterpriseInfo.econKind }}</span>
                        <span style="white-space: nowrap">{{ enterpriseInfo.personScope }}</span>
                    </p>
                    <ul class="job-ul">
                        <li>
                            <span>全部职位</span>
                            <span class="num">{{ enterpriseInfo.totalPublicJobNum }}个</span>
                        </li>
                        <li>
                            <span>在招职位</span>
                            <span class="num">{{ enterpriseInfo.recruitJobNum }}个</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="container clearfix">
            <el-tabs v-model="active" @tab-click="handleClick">
                <el-tab-pane label="企业介绍" name="introduce">
                    <introduce :enterpriseInfo="enterpriseInfo"></introduce>
                </el-tab-pane>
                <el-tab-pane label="全部职位" name="inRecruit">
                    <div class="inRecruit">
                        <common-search @search="handleAllSearch"></common-search>
                        <div class="mianContent clearfix">
                            <common-list
                                    :jobPositionList="allJobPositionList"
                                    :searchParams="allSearchParams"
                                    :page="allPage"
                                    @pageNumber="handleAllPageChange"
                                    :type="'allPosition'"
                            ></common-list>
                            <img-block></img-block>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
    import Introduce from "./components/Introduce.vue";
    import ImgBlock from "../jobList/components/ImgBlock/index.vue";

    import CommonSearch from "./components/CommonSearch";
    import CommonList from "./components/CommonList";

    import {getInfoExtByEnterpriseId} from "@/api/enterprise";

    export default {
        name: "CompanyDetails",
        components: {Introduce, ImgBlock, CommonSearch, CommonList},
        data() {
            return {
                tags: ["高新企业", "广东省产教融合领军企业", "高新企业"],
                active: "introduce",
                inRecruitParams: null,
                enterpriseInfo: {},

                allJobPositionList: [],
                allSearchParams: {
                    pageNumber: 1,
                    pageSize: 10,
                    keyword: "", //关键字
                    willNature: "", // 工作性质（实习，兼职，全职）
                    wageList: [], //
                },
                allPage: {
                    totalElements: 0,
                },
                interval: null,
            };
        },
        computed: {
            label() {
                try {
                    return JSON.parse(this.enterpriseInfo.label);
                } catch (e) {
                    return [];
                }
            },
        },
        created() {
            this.active = this.$route.query.tab || "introduce";
            if (this.active == "inRecruit") {
                this.interval = setInterval(() => {
                    if (this.enterpriseInfo.enterpriseId) {
                        this.getAllPositionList(this.allSearchParams);
                        clearInterval(this.interval);
                    }
                }, 500);
            }
            this.loadData();
        },
        methods: {
            //所有职位查询
            handleAllSearch(params) {
                this.allSearchParams.keyword = params.keyword;
                this.allSearchParams.wageList = params.wageList;
                this.allSearchParams.willNature = params.willNature;
                this.getAllPositionList(this.allSearchParams);
            },
            //所有职位翻页
            handleAllPageChange(number) {
                this.allSearchParams.pageNumber = number;
                this.getAllPositionList(this.allSearchParams);
            },
            //获取所有职位列表
            getAllPositionList(params) {
                params["enterpriseId"] = this.enterpriseInfo.enterpriseId;
                this.$store.dispatch("global/getJobPositionList", params).then((res) => {
                    this.allPage.totalElements = parseInt(res.data.totalElements);
                    this.allJobPositionList = res.data.content;
                });
            },
            openWebsite(website) {
                open(website);
            },
            loadData() {
                getInfoExtByEnterpriseId(this.$route.params.companyId).then((res) => {
                    this.enterpriseInfo = res.data;
                });
            },
            industryFormatter(industry) {
                try {
                    return JSON.parse(industry).join("/");
                } catch (e) {
                    return "";
                }
            },
            handleClick(tab) {
                this.$router.push(
                    `/companyDetails/${this.$route.params.companyId}?tab=${tab.name}`
                );
                if (tab.name === "inRecruit") {
                    if (this.allJobPositionList.length == 0) {
                        this.getAllPositionList(this.allSearchParams);
                    }
                }
            },
        },
    };
</script>
<style lang="scss" scoped>
    .companyDetailsMain.mobile {
        padding: 0 12px;
        padding-top: 15px;
        box-sizing: border-box;

        .companyTit-mobile {
            .info-container {
                display: flex;

                background: #323b57 url("../../../../../public/images/jobTitBg.png") no-repeat left top;
                border-radius: 10px;
                padding: 18px 0 21px 12px;
                color: #fff;

                > img {
                    width: 75px;
                    height: 75px;
                    border-radius: 5px;
                    background: #fff;
                }

                .info {
                    margin-left: 15px;

                    > h3 {
                        font-weight: 600;
                        font-size: 18px;
                        margin-bottom: 8px;

                        ::v-deep .el-button {
                            padding: 4px 6px;
                            margin-left: 18px;
                            border-radius: 4px;
                            position: relative;
                            top: -4px;
                        }
                    }

                    .textInfo {
                        margin-bottom: 8px;
                        line-height: 20px;
                    }

                    .job-ul {
                        display: flex;

                        li {
                            padding: 6px 8px;
                            border: 1px solid rgba(255, 2255, 255, 0.5);
                            border-radius: 6px;
                            text-align: center;
                            margin-right: 10px;

                            .num {
                                margin-left: 5px;
                                font-weight: 600;
                            }
                        }
                    }
                }
            }
        }

        .container {
            ::v-deep .el-tabs__nav-scroll {
                background: #fff;
                margin-top: 15px;

                .el-tabs__nav-scroll {
                    border-radius: 6px;
                }

                .el-tabs__nav {
                    width: 100%;
                    display: flex;

                    &::after {
                        content: "";
                        display: block;
                        position: absolute;
                        width: 1px;
                        height: 12px;
                        background: #f4f4f4;
                        top: 50%;
                        left: 50%;
                        margin-top: -6px;
                        margin-left: -0.5px;
                    }

                    .el-tabs__item.is-top {
                        flex: 1;
                        padding: 0;
                        text-align: center;
                    }
                }
            }

            // ::v-deep .el-tabs__header {
            //   margin-bottom: 0;
            // }
        }
    }
</style>
